var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { STOCK_SURVILLANCE, STOCK_SURVILLANCE_CLEAR_MSG, STOCK_SURVILLANCE_ERROR, STOCK_SURVILLANCE_HIDE_ERROR, STOCK_SURVILLANCE_MSG, STOCK_SURVILLANCE_START_LOADER, STOCK_SURVILLANCE_STOP_LOADER, } from "../interface/iStockSurvillance";
var initialState = {
    data: {
        asm: {
            longTerm: {
                asOnDate: "",
                stkList: [],
            },
            shortTerm: {
                asOnDate: "",
                stkList: [],
            },
        },
        gsm: {
            asOnDate: "",
            stkList: [],
        },
        fnoBanList: {
            asOnDate: "",
            securities: [],
            possibleEntrance: [],
            possibleExits: [],
        },
    },
    asmMessage: {
        msg: null,
        show: false,
        icon: null,
    },
    gsmMessage: {
        msg: "",
        show: false,
        icon: "",
    },
    fnoBanMessage: {
        msg: "",
        show: false,
        icon: "",
    },
    stockSurveillanceLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
var stockSurveillanceReducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case STOCK_SURVILLANCE:
            return __assign(__assign({}, state), { data: action.payload.data });
        case STOCK_SURVILLANCE_ERROR:
            return __assign(__assign({}, state), { errorData: action.payload.errorData });
        case STOCK_SURVILLANCE_MSG:
            return __assign(__assign({}, state), (_a = {}, _a[action.errorMsg] = action.payload.message, _a));
        case STOCK_SURVILLANCE_CLEAR_MSG:
            return __assign(__assign({}, state), (_b = {}, _b[action.errorMsg] = initialState[action.errorMsg], _b));
        case STOCK_SURVILLANCE_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: initialState.errorData });
        case STOCK_SURVILLANCE_START_LOADER:
            return __assign(__assign({}, state), { stockSurveillanceLoader: true });
        case STOCK_SURVILLANCE_STOP_LOADER:
            return __assign(__assign({}, state), { stockSurveillanceLoader: false });
        default:
            return __assign({}, state);
    }
};
export default stockSurveillanceReducer;
